import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyObject = { [key: string]: any };
interface IProps {
    object: AnyObject;
    keys: string[];
    render(arg: object): JSX.Element;
    mergeObject?(argA: AnyObject): AnyObject;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const identity = (arg: any) => arg;

export class ContextMerger extends React.Component<IProps> {
    static displayName = 'ContextMerger';

    static getKeysFromObject(keys: string[], object: AnyObject) {
        return keys.reduce((acc, field) => {
            if (object.hasOwnProperty(field)) {
                return {
                    ...acc,
                    [field]: object[field]
                };
            }

            return acc;
        }, {} as object);
    }

    public render() {
        const { mergeObject = identity, keys, object } = this.props;

        const objectWithRequestedKeys = ContextMerger.getKeysFromObject(keys, object);
        const value = mergeObject(objectWithRequestedKeys);

        return this.props.render(value);
    }
}
